import ownerDocument from '@mui/utils/ownerDocument';
export default ownerDocument;
